export default __webpack_public_path__ + "images/vc-e19034240ae39be40a4c1ce9a31b3ba7.svg";